import React from 'react';
import '../../TasksPage.css';

function QuickStatsRow({ stats, dateRange }) {
  const quickStats = [
    {
      label: 'Today',
      value: stats.today?.completed || 0,
      trend: null,
      color: '#3b82f6'
    },
    {
      label: 'This Week',
      value: stats.this_week?.completed || 0,
      trend: stats.comparison?.vs_last_week_percent || 0,
      color: '#10b981'
    },
    {
      label: 'Completion Rate',
      value: `${stats.this_week?.completion_rate || 0}%`,
      trend: null,
      color: '#f59e0b'
    },
    {
      label: 'Pending',
      value: stats.today?.pending || 0,
      trend: null,
      color: '#ef4444'
    }
  ];

  return (
    <div className="quick-stats-row">
      {quickStats.map((stat, index) => (
        <div key={index} className="quick-stat-card" style={{ '--stat-color': stat.color }}>
          <div className="stat-value">{stat.value}</div>
          <div className="stat-label">{stat.label}</div>
          {stat.trend !== null && stat.trend !== 0 && (
            <div className={`stat-trend ${stat.trend > 0 ? 'positive' : 'negative'}`}>
              {stat.trend > 0 ? '↑' : '↓'} {Math.abs(stat.trend)}%
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default QuickStatsRow;
